import { Directive, ElementRef, HostBinding, Input, SimpleChanges } from '@angular/core';
import { RightService } from 'src/app/services/right.service';
import { User } from 'src/app/shared/models/user/user';
import { UserSessionService } from 'src/app/tinea-components/okta/services/session/user-session.service';
import { ApplicationFeature, UserType } from 'src/swagger-gen/web-secured/models';

@Directive({
    selector: '[appReadWrite]',
    standalone: false
})
export class ReadWriteDirective {

  disabled : boolean;
  @HostBinding('attr.disabled') attrDisabled : boolean;
  @HostBinding('class.hide-header') aHideHeaderClass: boolean;
  @Input() appReadWrite: ApplicationFeature;

  user: User;
  currentAuthorization: ApplicationFeature;

  constructor(private el: ElementRef,
              private rightService: RightService,
              private userSessionService: UserSessionService) {    
    this.user = this.userSessionService.getUser();
    this.currentAuthorization = rightService.currentAuthorization;
      
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appReadWrite) {
      if (this.user) {
        this.setDisabled();
      }  
    }
  }

  setDisabled(): void {
    let disabled = true;
    const reference = this.appReadWrite || this.currentAuthorization;
    disabled = this.rightService.isDisabled(reference);
    this.disabled = disabled;
    if (disabled) {
      this.attrDisabled = disabled;
      this.aHideHeaderClass = disabled;
    }
  }
}
